import { useEffect, useState } from 'react';
import config from '../../config/config';
import DownloadButton from './DownloadButton';
import axios from 'axios';

export default function AttendeesCard({ prefix, cardType }) {
  const table_headers = [
    { label: 'Name', key: 'contact' },
    { label: 'Title', key: 'contact_title' },
    { label: 'Email', key: 'contact_email' },
    { label: 'Phone', key: 'contact_phone' },
    { label: 'Ext,', key: 'ext' },
    { label: 'City', key: 'city' }
  ];

  const [attendeeData, setAttendeeData] = useState();
  const [fileName, setFileName] = useState();
  useEffect(() => {
    async function getattendeeData() {
      if (
        prefix.match(/outreach\/meetings\/\d+/) ||
        prefix.match(/outreach\/emails\/\d+/)
      ) {
        const uid = prefix.split('/')[2];
        setFileName(
          cardType === 'meeting'
            ? `meeting_${uid}_attendees`
            : cardType === 'email'
            ? `email_${uid}_recipients`
            : undefined
        );
        axios
          .get(
            config.apiURL +
              `/${
                cardType === 'meeting'
                  ? 'meetings_attendees_details'
                  : 'email_recipients_details'
              }/${uid}`,
            {
              headers: {
                'Content-Type': 'application/json',
                token: config.getToken()
              }
            }
          )
          .then((response) => {
            return setAttendeeData(response.data);
          });
      }
    }
    getattendeeData();
  }, [prefix]); // eslint-disable-line react-hooks/exhaustive-deps

  if (attendeeData) {
    return (
      <div className='row'>
        <div
          className='col-xl-1-12'
          style={{ margin: '10px', background: '#1A4565', border: 'double' }}
        >
          <div className='card' style={{ border: 'none', width: '100%' }}>
            <div
              className='card-body'
              style={{ width: '100%', background: 'lightBlue' }}
            >
              <h3 className='card-title' style={{ marginLeft: '10px' }}>
                {cardType === 'meeting' ? 'Attendees' : 'Recipients'}
              </h3>
              <table>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Title</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Ext</th>
                    <th>City</th>
                  </tr>
                </thead>
                <tbody>
                  {attendeeData.map((meeting, idx) => (
                    <tr key={idx}>
                      <td style={{ textAlign: 'center' }}>
                        <a
                          // target='_blank'
                          style={{ color: 'blue', textAlign: 'right' }}
                          rel='noreferrer'
                          href={`/summary/${meeting.contact}/${meeting.contact_id}/${meeting.poc_id}`}
                        >
                          {meeting.contact}
                        </a>
                      </td>
                      {/* <td style={{ textAlign: 'center' }}>{meeting.contact}</td> */}
                      <td style={{ textAlign: 'center' }}>
                        {meeting.contact_title}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {meeting.contact_email}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {meeting.contact_phone}
                      </td>
                      <td style={{ textAlign: 'center' }}>{meeting.ext}</td>
                      <td style={{ textAlign: 'center' }}>{meeting.city}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <hr style={{ color: 'grey' }} />
            </div>
          </div>
          <DownloadButton
            new_data={attendeeData}
            headers={table_headers}
            file={fileName}
          />
        </div>
      </div>
    );
  }
  return <></>;
}
